import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { useRef, useEffect, useCallback } from 'react';
import { CloseOutline } from '@olist/design-system-icons';
import { DialogModal, DialogContainer, CloseModal, HeaderModal, BodyModal, FooterModal } from './styles.js';
import 'styled-components';
import { noop } from '../../utils/noop.js';
import '../../utils/opacityDisabled.js';
import { ButtonIcon } from '../ButtonIcon/ButtonIcon.js';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import Title from '../Text/Title/Title.js';

const Modal = (_a) => {
    var { title, description, body, footer, size, closeButtonAriaLabel, isOpen, as, id, onClose = noop } = _a, props = __rest(_a, ["title", "description", "body", "footer", "size", "closeButtonAriaLabel", "isOpen", "as", "id", "onClose"]);
    const dialogRootRef = useRef(null);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (isOpen && !((_a = dialogRootRef.current) === null || _a === void 0 ? void 0 : _a.open)) {
            (_b = dialogRootRef.current) === null || _b === void 0 ? void 0 : _b.showModal();
        }
        if (!isOpen && ((_c = dialogRootRef.current) === null || _c === void 0 ? void 0 : _c.open)) {
            (_d = dialogRootRef.current) === null || _d === void 0 ? void 0 : _d.close();
        }
    }, [isOpen]);
    const handleOnCancel = useCallback((event) => {
        event.preventDefault();
        onClose();
    }, [onClose]);
    const handleClickAway = useCallback((event) => {
        if (event.target.nodeName === 'DIALOG') {
            onClose();
        }
    }, [onClose]);
    return (React.createElement(DialogModal, { ref: dialogRootRef, onClick: handleClickAway, onCancel: handleOnCancel, size: size, id: id },
        React.createElement(DialogContainer, Object.assign({ as: as }, props),
            React.createElement(CloseModal, null,
                React.createElement(ButtonIcon, { "aria-label": closeButtonAriaLabel ? closeButtonAriaLabel : 'fechar modal', variation: "secondary", icon: React.createElement(CloseOutline, null), onClick: onClose })),
            React.createElement(HeaderModal, null,
                React.createElement(Title, { type: "default" }, title),
                description && React.createElement(Caption, { type: "default" }, description)),
            React.createElement(BodyModal, null, body),
            footer && React.createElement(FooterModal, null, footer))));
};
Modal.displayName = 'Modal';

export { Modal };
